import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class SalaryScaleService {

  constructor(private http: HttpClient) { }

  getScales() {
    return this.http.get<any>(Library.API_ENDPOINT + 'scale/get_scale_list', OPTIONS);
  }

  createUpdateScale(scaleForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `scale/save_update_scale`, scaleForm, OPTIONS);
  }

  deleteScale(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `scale/delete_scale/${id}`, OPTIONS);
  }

  createUpdateScaleLine(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `scale/save_update_scale_line`, elementForm, OPTIONS);
  }

  deleteScaleLine(selectedIds: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `scale/delete_scale_line`, selectedIds, OPTIONS);
  }
}
